module.exports = __webpack_public_path__ + "static/myconid_sovereign-5d06f626cf9ba28fc260249b7522cece.jpg";